/**
 * Blog API Service
 * Handles public blog/news related API calls
 */

import { get } from "./client";

export interface ApiPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  content: string;
  metaDescription: string | null;
  keywords: string | null;
  seoTitle: string | null;
  seoDescription: string | null;
  seoKeywords: string | null;
  status: string;
  publishedAt: string | null;
  author?: {
    id: string;
    fullName: string;
  };
  categories?: Array<{
    id: string;
    name: string;
    slug: string;
  }>;
  tags?: Array<{
    id: string;
    name: string;
    slug: string;
  }>;
  medias?: Array<{
    id: string;
    fileUrl: string;
    fileType: string;
  }>;
  postView?: {
    views: number;
  };
}

interface PostsResponse {
  message: string;
  data: ApiPost[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
    firstPage: number;
  };
}

interface PostResponse {
  message: string;
  data: ApiPost;
}

/**
 * Get all published posts
 */
export async function getPublicPosts(
  page = 1,
  limit = 20,
  category?: string
): Promise<PostsResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  if (category) params.append("category", category);

  return await get<PostsResponse>(
    `/public/posts?${params.toString()}`,
    undefined,
    undefined,
    false
  );
}

/**
 * Get post by slug
 * @param slug - Post slug
 * @param skipView - If true, won't increment view count
 */
export async function getPublicPostBySlug(
  slug: string,
  skipView: boolean = false
): Promise<PostResponse> {
  const params = skipView ? { skip_view: "1" } : undefined;
  return await get<PostResponse>(
    `/public/posts/${slug}`,
    params,
    undefined,
    false
  );
}
